'use client'

import 'photoswipe/dist/photoswipe.css'
import PhotoSwipeLightbox, { PhotoSwipeOptions } from 'photoswipe/lightbox'
import 'photoswipe/style.css'
import { useEffect } from 'react'

interface DynamicPhotoSwipeProps {
  id: string
  options?: Partial<PhotoSwipeOptions>
}

const DynamicPhotoSwipe: React.FC<DynamicPhotoSwipeProps> = ({
  id,
  options,
}) => {
  useEffect(() => {
    let lightbox: PhotoSwipeLightbox | null = new PhotoSwipeLightbox({
      gallery: `#${id}`,
      children: 'a',
      pswpModule: () => import('photoswipe'),
      ...options,
    })

    lightbox.init()

    return () => {
      lightbox?.destroy()
      lightbox = null
    }
  }, [id, options])

  return null // This component does not render anything itself
}

export default DynamicPhotoSwipe
